export const useInsiderLevel = () => {
  const authStore = useAuthStore();
  const { data: packagesData } = usePackages();

  const userPackage = computed(() => {
    const user = authStore.getUser;

    if (!user || !(user as any).packageId || !packagesData.value?.data) {
      return null;
    }

    return packagesData.value.data.find((pkg: any) => pkg.id === (user as any).packageId) || null;
  });

  const badgeNumber = computed(() => {
    return userPackage.value ? (userPackage.value as any).badgeNumber : null;
  });

  const badgeColor = computed(() => {
    return userPackage.value ? (userPackage.value as any).badgeColor : null;
  });

  const packageName = computed(() => {
    return userPackage.value ? userPackage.value.name : null;
  });

  return {
    userPackage,
    badgeNumber,
    badgeColor,
    packageName,
  };
};
